import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-a1940',
  templateUrl: './a1940.component.html',
  styleUrls: ['./a1940.component.css']
})
export class A1940Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
